module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_0.838443eb.png";